const AuthorizationSchema = [
  {
    name: "Welcome",
    url: "/welcome",
    resps: [
      "LAWYER",
      "SECRETARY",
      "ACCOUNTING",
      "MPARTNER",
      "PARTNERQ",
      "PARTNERS"
    ],
    icon: "cui-lightbulb"
  },
  {
    name: "Overall Dashboard",
    resps: [
      "LAWYER",
      "SECRETARY",
      "ACCOUNTING",
      "MPARTNER",
      "PARTNERQ",
      "PARTNERS"
    ],
    icon: "fa fa-info-circle",
    children: [
      {
        name: "Dashboard",
        url: "/dashboard",
        resps: [
          "LAWYER",
          "SECRETARY",
          "ACCOUNTING",
          "MPARTNER",
          "PARTNERQ",
          "PARTNERS"
        ],
        icon: "icon-speedometer"
      },
      {
        name: "Business Dashboard",
        url: "/businessdashboard",
        resps: [
          "LAWYER",
          "SECRETARY",
          "ACCOUNTING",
          "MPARTNER",
          "PARTNERQ",
          "PARTNERS"
        ],
        icon: "fa fa-dashboard"
      },
      {
        name: "Finance Dashboard",
        url: "/financedashboard",
        resps: [
          "LAWYER",
          "SECRETARY",
          "ACCOUNTING",
          "MPARTNER",
          "PARTNERQ",
          "PARTNERS"
        ],
        icon: "fa fa-dollar"
      },
      {
        name: "HC Dashboard",
        url: "/hcdashboard",
        resps: [
          "LAWYER",
          "SECRETARY",
          "ACCOUNTING",
          "MPARTNER",
          "PARTNERQ",
          "PARTNERS"
        ],
        icon: "fa fa-users"
      },
      {
        name: "Supporting Dashboard",
        icon: "fa fa-info-circle",
        resps: [
          "LAWYER",
          "SECRETARY",
          "ACCOUNTING",
          "MPARTNER",
          "PARTNERQ",
          "PARTNERS"
        ],
        url: "#/"
      }
    ]
  },
  {
    name: "Finance",
    icon: "fa fa-retweet",
    resps: ["ACCOUNTING"],
    url: "#/",
    children: [
      {
        name: "Cash Flow",
        icon: "fa fa-line-chart",
        resps: ["ACCOUNTING"],
        url: "/cashflow"
      },
      {
        name: "Cash Position",
        icon: "fa fa-map-marker",
        resps: ["ACCOUNTING"],
        url: "/CashPosition"
      },
      {
        name: "Account Receivable",
        icon: "fa fa-money",
        resps: ["ACCOUNTING"],
        url: "#/",
        children: [
          {
            name: "AR List",
            url: "/arlist",
            resps: ["ACCOUNTING"],
            icon: "fa fa-file-excel-o"
          },
          {
            name: "AR Input",
            url: "/arinput",
            resps: ["ACCOUNTING"],
            icon: "fa fa-wpforms"
          }
        ]
      },
      {
        name: "Account Payable",
        icon: "fa fa-money",
        resps: ["ACCOUNTING"],
        url: "#/",
        children: [
          {
            name: "AP List",
            url: "/aplist",
            resps: ["ACCOUNTING"],
            icon: "fa fa-file-excel-o"
          },
          {
            name: "AP Input",
            url: "/apinput",
            resps: ["ACCOUNTING"],
            icon: "fa fa-wpforms"
          }
        ]
      }
    ]
  },
  {
    name: "Prospect",
    url: "/administrator",
    resps: ["LAWYER", "SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
    icon: "fa fa-handshake-o",
    children: [
      {
        name: "Prospect Board",
        url: "/caseboard/overview",
        resps: ["SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
        icon: "fa fa-sticky-note"
      },
      {
        name: "Add New Prospect",
        url: "/caseprospect",
        resps: ["SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
        icon: "fa fa-plus"
      }
    ]
  },
  {
    name: "Cases",
    url: "/administrator",
    resps: ["SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
    icon: "fa fa-pencil-square",
    children: [
      {
        name: "Case Overview",
        url: "/cases",
        resps: ["SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
        icon: "fa fa-eye"
      },
      {
        name: "Case Board",
        url: "/caseboard/only_active",
        resps: ["SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
        icon: "fa fa-sticky-note"
      },
      {
        name: "Case List",
        url: "/caselist",
        resps: ["SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
        icon: "fa fa-th-list"
      },
      {
        name: "Add New Case",
        url: "/casenew",
        resps: ["SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
        icon: "fa fa-plus"
      }
    ]
  },
  {
    name: "Personal",
    icon: "fa fa-user",
    resps: ["LAWYER", "SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
    url: "/administrator",
    children: [
      {
        name: "Timesheet",
        url: "/timesheet/input",
        resps: ["LAWYER", "SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
        icon: "fa fa-calendar-o"
      },
      {
        name: "Timesheet Review",
        url: "/timesheets/view",
        resps: ["LAWYER", "SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
        icon: "fa fa-eye"
      },
      {
        name: "Employee Page",
        url: "/profile/13/info",
        resps: ["LAWYER", "SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
        icon: "fa fa-users"
      }
    ]
  },
  {
    name: "Administrator",
    url: "/administrator",
    resps: ["SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
    icon: "fa fa-book",
    children: [
      {
        name: "Master Data",
        url: "/adminstrator",
        resps: ["SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
        icon: "fa fa-list",
        children: [
          {
            name: "User Login",
            url: "/administrator/users",
            resps: ["SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
            icon: "fa fa-user"
          },
          {
            name: "Matter",
            icon: "fa fa-book",
            resps: ["SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
            url: "/administrator/matter_configurations",
            children: [
              {
                name: "Matter Update Template",
                url:
                  "/administrator/matter_configurations/case_update_template",
                resps: ["SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
                icon: "fa fa-warning"
              },
              {
                name: "Case Flags",
                url: "/administrator/matter_configurations/case_flags",
                resps: ["SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
                icon: "fa fa-flag"
              }
            ]
          },
          {
            name: "Human Capital",
            url: "/administrator/human_capital",
            resps: ["SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
            icon: "fa fa-book",
            children: [
              {
                name: "Medical Reimbursement Plan",
                url: "/administrator/human_capital/med_reimbursement_plan",
                resps: ["SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
                icon: "fa fa-warning"
              }
            ]
          },
          {
            name: "Approval System",
            url: "/administrator/approvals",
            resps: ["SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
            icon: "fa fa-check",
            children: [
              {
                name: "General Approval System",
                url: "/administrator/approvals/general",
                resps: ["SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
                icon: "fa fa-check-circle"
              },
              {
                name: "Approval Settings",
                url: "/administrator/approvals/settings",
                resps: ["SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
                icon: "fa fa-check-circle"
              }
            ]
          },
          {
            name: "Practices",
            url: "/administrator/master/practices",
            resps: ["SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
            icon: "fa fa-user"
          },
          {
            name: "Sectors",
            url: "/administrator/master/sectors",
            resps: ["SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
            icon: "fa fa-user"
          },
          {
            name: "Vendors",
            url: "/administrator/master/vendors",
            resps: ["SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
            icon: "fa fa-user"
          },
          {
            name: "Document Type",
            url: "/administrator/master/document_types",
            resps: ["SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
            icon: "fa fa-user"
          },
          {
            name: "Leave Category",
            url: "/administrator/leave_request_category",
            resps: ["SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
            icon: "fa fa-bus"
          }
        ]
      },
      {
        name: "Assignment",
        url: "/assignment",
        resps: ["SECRETARY", "MPARTNER", "PARTNERQ", "PARTNERS"],
        icon: "fa fa-puzzle-piece"
      }
    ]
  }
];
export default AuthorizationSchema;
